export default __webpack_public_path__ + "static/media/emoji_anger.74d63b36.png";